import React from "react";
import { Link } from "react-router-dom";
import { COMPANY, LOGO_URL } from "@/lib/api";
import { Phone, Mail, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-slate-200/80 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-3">
              <img
                src={LOGO_URL}
                alt="Laronta Pro Logistic LLC"
                className="h-12 w-12 rounded-full object-cover ring-1 ring-zinc-800"
              />
              <div className="leading-tight">
                <div className="font-heading font-black tracking-tight text-slate-900 text-sm">LARONTA PRO</div>
                <div className="text-[10px] uppercase tracking-[0.2em] text-slate-500">Logistic LLC</div>
              </div>
            </div>
            <p className="text-slate-500 text-sm mt-4 leading-relaxed">
              Dependable trucking, transportation, and logistics serving all 50 states.
              Delivering excellence every mile.
            </p>
          </div>

          <div>
            <div className="text-xs uppercase tracking-[0.2em] font-bold text-primary-brand mb-4">Services</div>
            <ul className="space-y-2 text-sm text-slate-600">
              <li><Link to="/services" className="hover:text-slate-900">Local & Regional Freight</Link></li>
              <li><Link to="/services" className="hover:text-slate-900">Last-Mile Delivery</Link></li>
              <li><Link to="/commercial" className="hover:text-slate-900">Commercial Deliveries</Link></li>
              <li><Link to="/services" className="hover:text-slate-900">Residential Deliveries</Link></li>
              <li><Link to="/services" className="hover:text-slate-900">Expedited Freight</Link></li>
              <li><Link to="/services" className="hover:text-slate-900">Contract Delivery</Link></li>
            </ul>
          </div>

          <div>
            <div className="text-xs uppercase tracking-[0.2em] font-bold text-primary-brand mb-4">Quick Links</div>
            <ul className="space-y-2 text-sm text-slate-600">
              <li><Link to="/track" className="hover:text-slate-900">Track a Shipment</Link></li>
              <li><Link to="/quote" className="hover:text-slate-900">Request a Quote</Link></li>
              <li><Link to="/portal" className="hover:text-slate-900">Client Portal</Link></li>
              <li><Link to="/portal/register" className="hover:text-slate-900">Sign Up</Link></li>
              <li><Link to="/careers" className="hover:text-slate-900">Careers</Link></li>
              <li><Link to="/team" className="hover:text-slate-900">Our Team</Link></li>
              <li><Link to="/service-area" className="hover:text-slate-900">Service Area</Link></li>
              <li><Link to="/contact" className="hover:text-slate-900">Contact Us</Link></li>
              <li><Link to="/admin/login" className="hover:text-slate-900">Admin Login</Link></li>
            </ul>
          </div>

          <div>
            <div className="text-xs uppercase tracking-[0.2em] font-bold text-primary-brand mb-4">Get in Touch</div>
            <ul className="space-y-3 text-sm text-slate-600">
              <li className="flex items-start gap-2"><Phone className="h-4 w-4 mt-0.5 text-primary-brand"/> <a href={`tel:${COMPANY.phoneRaw}`} className="hover:text-slate-900">{COMPANY.phone}</a></li>
              <li className="flex items-start gap-2"><Mail className="h-4 w-4 mt-0.5 text-primary-brand"/> <a href={`mailto:${COMPANY.email}`} className="hover:text-slate-900 break-all">{COMPANY.email}</a></li>
              <li className="flex items-start gap-2"><MapPin className="h-4 w-4 mt-0.5 text-primary-brand"/> {COMPANY.location}</li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-slate-200 flex flex-col md:flex-row justify-between gap-4 text-xs text-slate-400">
          <div>© {new Date().getFullYear()} Laronta Pro Logistics LLC. All rights reserved.</div>
          <div className="uppercase tracking-[0.2em] font-bold text-slate-500">Delivering Excellence Every Mile.</div>
        </div>
      </div>
    </footer>
  );
}
